// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  position: relative;
  min-height: 704px;
}

::ng-deep .theme-toggle-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 16px;
  cursor: pointer;
  margin: 4px 8px;
  border-radius: 8px;
  background: rgba(0, 159, 207, 0.06);
  border: 1px solid rgba(0, 159, 207, 0.15);
  transition: background 0.2s ease;
}
::ng-deep .theme-toggle-item:hover {
  background: rgba(0, 159, 207, 0.12);
}
::ng-deep .theme-toggle-item .theme-toggle-icon {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #e5e7eb;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: background 0.3s ease;
}
::ng-deep .theme-toggle-item .theme-toggle-icon mat-icon {
  font-size: 20px;
  height: 20px;
  width: 20px;
  color: #374151;
}
::ng-deep .theme-toggle-item .theme-toggle-icon--dark {
  background: #1e3a5f;
}
::ng-deep .theme-toggle-item .theme-toggle-icon--dark mat-icon {
  color: #60a5fa;
}
::ng-deep .theme-toggle-item .theme-toggle-labels {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
}
::ng-deep .theme-toggle-item .theme-toggle-labels .theme-toggle-title {
  font-size: 13px;
  font-weight: 600;
  color: inherit;
  line-height: 1.3;
}
::ng-deep .theme-toggle-item .theme-toggle-labels .theme-toggle-mode {
  font-size: 11px;
  color: rgba(0, 159, 207, 0.9);
  font-weight: 500;
  line-height: 1.3;
}
::ng-deep .theme-toggle-item .theme-switch {
  margin-left: auto;
  width: 44px;
  height: 24px;
  border-radius: 12px;
  background: #d1d5db;
  position: relative;
  transition: background 0.3s ease;
  flex-shrink: 0;
}
::ng-deep .theme-toggle-item .theme-switch--on {
  background: #009fcf;
}
::ng-deep .theme-toggle-item .theme-switch .theme-switch-thumb {
  position: absolute;
  top: 3px;
  left: 3px;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3);
  transition: transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
}
::ng-deep .theme-toggle-item .theme-switch--on .theme-switch-thumb {
  transform: translateX(20px);
}`, "",{"version":3,"sources":["webpack://./src/app/app.component.scss"],"names":[],"mappings":"AAEA;EACE,kBAAA;EACA,iBAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;EACA,mCAAA;EACA,yCAAA;EACA,gCAAA;AADF;AAGE;EACE,mCAAA;AADJ;AAIE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,gCAAA;AAFJ;AAII;EAAW,eAAA;EAAiB,YAAA;EAAc,WAAA;EAAa,cAAA;AAE3D;AAAI;EACE,mBAAA;AAEN;AADM;EAAW,cAAA;AAIjB;AAAE;EACE,aAAA;EACA,sBAAA;EACA,OAAA;EACA,YAAA;AAEJ;AAAI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AAEN;AACI;EACE,eAAA;EACA,6BAAA;EACA,gBAAA;EACA,gBAAA;AACN;AAGE;EACE,iBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gCAAA;EACA,cAAA;AADJ;AAGI;EAAQ,mBAAA;AAAZ;AAEI;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,wCAAA;EACA,4DAAA;AAAN;AAGI;EACE,2BAAA;AADN","sourcesContent":["@use '@gravity-angular/styles/lib/variables/base';\n\n:host {\n  position: relative;\n  min-height: base.base(88);\n}\n\n::ng-deep .theme-toggle-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 10px 16px;\n  cursor: pointer;\n  margin: 4px 8px;\n  border-radius: 8px;\n  background: rgba(0, 159, 207, 0.06);\n  border: 1px solid rgba(0, 159, 207, 0.15);\n  transition: background 0.2s ease;\n\n  &:hover {\n    background: rgba(0, 159, 207, 0.12);\n  }\n\n  .theme-toggle-icon {\n    width: 36px;\n    height: 36px;\n    border-radius: 50%;\n    background: #e5e7eb;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n    transition: background 0.3s ease;\n\n    mat-icon { font-size: 20px; height: 20px; width: 20px; color: #374151; }\n\n    &--dark {\n      background: #1e3a5f;\n      mat-icon { color: #60a5fa; }\n    }\n  }\n\n  .theme-toggle-labels {\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n    min-width: 0;\n\n    .theme-toggle-title {\n      font-size: 13px;\n      font-weight: 600;\n      color: inherit;\n      line-height: 1.3;\n    }\n\n    .theme-toggle-mode {\n      font-size: 11px;\n      color: rgba(0, 159, 207, 0.9);\n      font-weight: 500;\n      line-height: 1.3;\n    }\n  }\n\n  .theme-switch {\n    margin-left: auto;\n    width: 44px;\n    height: 24px;\n    border-radius: 12px;\n    background: #d1d5db;\n    position: relative;\n    transition: background 0.3s ease;\n    flex-shrink: 0;\n\n    &--on { background: #009fcf; }\n\n    .theme-switch-thumb {\n      position: absolute;\n      top: 3px;\n      left: 3px;\n      width: 18px;\n      height: 18px;\n      border-radius: 50%;\n      background: #fff;\n      box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3);\n      transition: transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);\n    }\n\n    &--on .theme-switch-thumb {\n      transform: translateX(20px);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
